export const enum ChartType3dEnum {
  bar3d = 'bar3d',
  histogram3d = 'histogram3d',
  rangeColumn3d = 'rangeColumn3d',
  pie3d = 'pie3d',
  wordCloud3d = 'wordCloud3d',
  funnel3d = 'funnel3d'
}

export const enum MarkType3dEnum {
  rect3d = 'rect3d',
  arc3d = 'arc3d',
  pyramid3d = 'pyramid3d'
}

export enum SeriesType3dEnum {
  bar3d = 'bar3d',
  rangeColumn3d = 'rangeColumn3d',
  pie3d = 'pie3d',
  wordCloud3d = 'wordCloud3d',
  funnel3d = 'funnel3d'
}

export const enum SeriesMark3dNameEnum {
  bar3d = 'bar3d',
  funnel3d = 'funnel3d',
  transform3d = 'transform3d',
  pie3d = 'pie3d'
}

/** 带有方向信息的系列类型，作为主题相关的补充类型 */
export enum SeriesType3dForThemeEnum {
  bar3d_horizontal = 'bar3d_horizontal',
  bar3d_vertical = 'bar3d_vertical',
  bar3d_stack = 'bar3d_stack',

  rangeColumn3d_horizontal = 'rangeColumn3d_horizontal',
  rangeColumn3d_vertical = 'rangeColumn3d_vertical'
}
